export const help = {
    'default' : 'Online_Help.html',
	
	//交换机
	'switchportView':                            '/Online_Help.html#switch_port_view.html',  //端口
	'switchView':                            '/Online_Help.html#mnt_chk_switch.html', //交换机
	'simplifyswitchportView':                            '/Online_Help.html#simplify_switchinterface.html', //极简端口
	
	//报表模板
	'templateCreate':                            '/Online_Help.html#template_periodic.html',  //创建
	'templateDownload':                            '/Online_Help.html#template_download.html', //下载
	'templateModify':                            '/Online_Help.html#template_periodic_modify.html', //修改
	
	//防勒索
	'deployAntiransomwareManage':                            '/Online_Help.html#hyperdetect_config.html', 
	
	//SmartMove--阵列间
	'movedomainCreate':                            '/Online_Help.html#move_inter_domain_create.html', //创建域
	'movedomainView':                            '/Online_Help.html#move_inter_domain_view.html', //浏览域
	'movedomainModify':                            '/Online_Help.html#move_inter_domain_modify.html', //修改域
	'fsvstoremoveCreate':                            '/Online_Help.html#move_inter_vstore_create.html', //创建租户Pair
	'fsvstoremoveView':                            '/Online_Help.html#move_inter_vstore_view.html', //浏览租户Pair
	'fsvstoremoveModify':                            '/Online_Help.html#move_inter_vstore_modify.html', //修改租户Pair
	'fsmoveCreate':                            '/Online_Help.html#move_inter_pair_create.html', //创建文件Pair
	'fsmoveView':                            '/Online_Help.html#move_inter_pair_view.html', //浏览文件Pair
	'fsmoveModify':                            '/Online_Help.html#move_inter_pair_modify.html', //修改文件Pair
	
	//诊断
	'diagnosisManage':                            '/Online_Help.html#diagnosis_task_manage.html', //管理
	'diagnosisCreate':                            '/Online_Help.html#diagnosis_task_create.html', //创建
	
	//netspace
	'spaceConfig':                            '/Online_Help.html#netspace.html', //管理
	'spaceView':                            '/Online_Help.html#netspace_view.html', //浏览
	'spaceCreate':                            '/Online_Help.html#netspace_create.html', //创建
	'spaceModify':                            '/Online_Help.html#netspace_modify.html', //修改
	'spaceAdd':  							'/Online_Help.html#netspace_add.html',//增加
	'spaceRemove':   	 					'/Online_Help.html#netspace_remove.html', //移除
	
	//极简模式
	'simplifyHelp':                            '/Online_Help.html#simplify_mode.html', //右上角极简模式入口
	'simplifylunManage':                            '/Online_Help.html#simplify_lun_manage.html', //管理LUN
	'simplifyhostManage':                            '/Online_Help.html#simplify_host_manage.html', //管理主机
	'simplifylunCreate':                            '/Online_Help.html#simplify_lun_create.html', //创建LUN
	'simplifylungroupCreate':                            '/Online_Help.html#simplify_lun_group_create.html', //创建LUN组
	'simplifylungroupManage':                            '/Online_Help.html#simplify_lun_group_manage.html', //管理LUN组
	'simplifyhostCreate':                            '/Online_Help.html#simplify_host_create.html', //创建主机
	'simplifyhostgroupCreate':                            '/Online_Help.html#simplify_host_group_create.html', //创建主机组
	'simplifyhostgroupManage':                            '/Online_Help.html#simplify_host_group_manage.html', //管理主机组
	
	'simplifyInitial':                            '/Online_Help.html#simplify_initial.html', //初始化配置
	'simplifyshareCreate':                            '/Online_Help.html#simplify_share_create.html', //创建文件共享
	'simplifyshareManage':                            '/Online_Help.html#simplify_share_manage.html', //管理文件共享
	'simplifynfsManage':                            '/Online_Help.html#simplify_share_manage_nfs.html', //管理NFS共享
	'simplifycifsManage':                            '/Online_Help.html#simplify_share_manage_cifs.html', //管理CIFS共享
	'simplifyfsManage':                            '/Online_Help.html#simplify_fs_manage.html', //管理文件系统
	'simplifyunixCreate':                            '/Online_Help.html#simplify_user_create_unxi_user.html', //创建unix本地认证用户
	'simplifyunixgroupCreate':                            '/Online_Help.html#simplify_user_create_unxi_user_group.html', //创建unix本地认证用户组
	'simplifywindowsCreate':                            '/Online_Help.html#simplify_user_create_windows_user.html', //创建windows本地认证用户
	'simplifywindowsgroupCreate':                            '/Online_Help.html#simplify_user_create_windows_user_group.html', //创建windows本地认证用户组
	'simplifymapCreate':                            '/Online_Help.html#simplify_user_create_map.html', //创建用户映射
	'simplifyunixManage':                            '/Online_Help.html#simplify_user_manage_unxi_user.html', //管理unix本地认证用户
	'simplifyunixgroupManage':                            '/Online_Help.html#simplify_user_manage_unxi_user_group.html', //管理unix本地认证用户组
	'simplifywindowsManage':                            '/Online_Help.html#simplify_user_manage_windows_user.html', //管理windows本地认证用户
	'simplifywindowsgroupManage':                            '/Online_Help.html#simplify_user_manage_windows_user_group.html', //管理windows本地认证用户组
	'simplifymapManage':                            '/Online_Help.html#simplify_user_manage_map.html', //管理用户映射
	'simplifyprotectionCreate':                            '/Online_Help.html#simplify_protection_create.html', //创建保护
	'simplifyspCreate':                            '/Online_Help.html#simplify_protection_snap_policy_create.html', //创建快照策略
	'simplifyprotectionManage':                            '/Online_Help.html#simplify_protection_manage.html', //管理保护
	'simplifyspoManage':                            '/Online_Help.html#simplify_protection_manage_once.html', //管理单次快照
	'simplifyspsManage':                            '/Online_Help.html#simplify_protection_manage_scheduled.html', //管理定时快照
	'simplifyspManage':                            '/Online_Help.html#simplify_protection_snap_policy_manage.html', //管理快照策略
	'simplifyalarmManage':                            '/Online_Help.html#simplify_alarm.html', //管理告警和事件
	'simplifytaskCreate':                            '/Online_Help.html#simplify_report_create.html', //创建任务
	'simplifytaskManage':                            '/Online_Help.html#simplify_report_manage.html', //管理任务
	'simplifyInventory':                            '/Online_Help.html#simplify_inventory.html', //资产清单
	'simplifyDevice':                            '/Online_Help.html#simplify_device.html', //设备信息
	'simplifyPerformance':                            '/Online_Help.html#simplify_performance.html', //性能
	'simplifyInfo':                            '/Online_Help.html#simplify_info.html', //设置设备信息
	'simplifyTime':                            '/Online_Help.html#simplify_time.html', //设置设备时间
	'simplifyuserCreate':                            '/Online_Help.html#simplify_user_per_create.html', //创建用户
	'simplifyroleCreate':                            '/Online_Help.html#simplify_user_role_create.html', //创建角色
	'simplifyuserManage':                            '/Online_Help.html#simplify_user_per_manage.html', //管理用户
	'simplifyroleManage':                            '/Online_Help.html#simplify_user_role_manage.html', //管理角色
	'simplifyemailManage':                            '/Online_Help.html#simplify_email.html', //配置邮件服务
	'simplifyNotify':                            '/Online_Help.html#simplify_notify.html', //配置邮件通知
	'simplifySMS':                            '/Online_Help.html#simplify_sms.html', //配置短信通知
	'simplifyDME':                            '/Online_Help.html#simplify_dme.html', //设置DME IQ
	'simplifyLIF':                            '/Online_Help.html#simplify_lif.html', //管理逻辑端口
	'simplifyETH':                            '/Online_Help.html#simplify_ethernet.html', //管理以太网络
	'simplifyRoCE':                            '/Online_Help.html#simplify_roce.html', //管理RoCE网络
	'simplifyFC':                            '/Online_Help.html#simplify_fc.html', //管理FC网络
	
	//总入口
	'simplifyLUN':                            '/Online_Help.html#simplify_lun_and_group.html', //LUN
	'simplifyHost':                            '/Online_Help.html#simplify_host_and_group.html', //主机
	'simplifyFile':                            '/Online_Help.html#simplify_file.html', //文件服务
	'simplifyProtection':                            '/Online_Help.html#simplify_protection.html', //数据保护
	'simplifyHardware':                            '/Online_Help.html#simplify_hardware.html', //存储硬件
	'simplifyReport':                            '/Online_Help.html#simplify_report.html', //报告
	'simplifySetting':                            '/Online_Help.html#simplify_setting.html', //设置
	'simplifyNetwork':                            '/Online_Help.html#simplify_network.html', //设置--网络管理
	'simplifyUser':                            '/Online_Help.html#simplify_user.html', //设置--用户和角色
	
	//SmartMove
	'moveConfig':                            '/Online_Help.html#move_config_manage.html', //SmartMove配置管理
	'moveView':                            '/Online_Help.html#move_view.html', //SmartMove浏览
	'moveCreate':                            '/Online_Help.html#move_create.html', //SmartMove创建
	'moveModify':                            '/Online_Help.html#move_modify.html', //SmartMove修改基本信息
	'moveModifySpeed':                            '/Online_Help.html#move_modify_speed.html', //SmartMove修改迁移速率
	
	//容器存储服务
	'pvView':                            '/Online_Help.html#pv_view.html', //pv
	'podView':                            '/Online_Help.html#pod_view.html', //pod
	
	//NFS客户端
	'nfsclientView':                            '/Online_Help.html#nfs_client_view.html', 
	
	//SmartMobility
	'mobilityConfig':                            '/Online_Help.html#mobility_config_manage.html', //SmartMobility配置管理
	'mobilityCreate':                            '/Online_Help.html#mobility_create.html', //SmartMobility创建
	'mobilityModfiy':                            '/Online_Help.html#mobility_modify.html', //SmartMobility修改基本信息
	'mobilitytimeModify':                            '/Online_Help.html#mobility_time_modify.html', //SmartMobility修改执行时间
	'mobilitypolicyAdd':                            '/Online_Help.html#mobility_add_policy.html', //SmartMobility增加策略
	'mobilitypolicyModify':                            '/Online_Help.html#mobility_modify_policy.html', //SmartMobility修改策略
	'policyCreate':                            '/Online_Help.html#mobility_policy.html', //策略模板创建
	'policyView':                            '/Online_Help.html#mobility_policy_view.html', //策略模板浏览
	'policyModify':                            '/Online_Help.html#mobility_policy_modify.html', //策略模板修改
	'mobilitydeviceAdd':                            '/Online_Help.html#mobility_device.html', //远端设备添加
	'mobilitydeviceView':                            '/Online_Help.html#mobility_device_view.html', //远端设备浏览
	'mobilitydeviceModify':                            '/Online_Help.html#mobility_device_modify.html', //远端设备修改
	'localipCreate':                            '/Online_Help.html#mobility_local_ip.html', //本端IP地址池创建
	'localipView':                            '/Online_Help.html#mobility_local_view.html', //本端IP地址池浏览
	'localipAddPort':                            '/Online_Help.html#mobility_local_add_port.html', //本端IP地址池增加逻辑端口
	'localipRemovePort':                            '/Online_Help.html#mobility_local_remove_port.html', //本端IP地址池移除逻辑端口
	'localipModify':                            '/Online_Help.html#mobility_local_modify.html', //本端IP地址池修改
	'remoteipCreate':                            '/Online_Help.html#mobility_remote_ip.html', //远端IP地址池创建
	'remoteipView':                            '/Online_Help.html#mobility_remote_view.html', //远端IP地址浏览
	'remoteipModify':                            '/Online_Help.html#mobility_remote_modify.html', //远端IP地址修改
	
	//容器
	'containerApplicationManage':                            '/Online_Help.html#application_manage.html',  //管理容器应用  
	'applicationCreate':                            '/Online_Help.html#application_deploy.html',  //部署应用 
	'applicationView':                            '/Online_Help.html#application_view.html',  //浏览应用 
	'applicationUpdate':                            '/Online_Help.html#application_update.html',  //更新应用 
	'containerRepositorykManage':                            '/Online_Help.html#repositorie_manage.html',  //管理仓库
	'uploadChart':                            '/Online_Help.html#chart_upload.html',  //导入chart
	'uploadImage':                            '/Online_Help.html#image_upload.html',  //导入镜像包
		
	//开局质检
	'qualityInspect':                            '/Online_Help.html#quality_inspection.html', 
	
	//白名单
	'cifsipAdd':                            '/Online_Help.html#fs_cifs_ip_add.html', //创建
	'cifsipModify':                            '/Online_Help.html#fs_cifs_ip_modify.html', //创建
	
	//远程复制租户Pair
	'fsvstorereplicationCreate':                            '/Online_Help.html#replicaiton_fs_create_vstore.html', //创建
	'fsvstorereplicationView':                            '/Online_Help.html#replicaiton_fs_view_vstore.html', //浏览
	
	//租户用户
	'vstoreuserCreate':                            '/Online_Help.html#vstore_user_create.html', //创建
	'vstoreuserModify':                            '/Online_Help.html#vstore_user_modify.html', //修改
	'vstoreuserView':                            '/Online_Help.html#vstore_user_view.html', //浏览
	//kerberos
	'kerberosAdd':                            '/Online_Help.html#kerberos_add.html', //创建
	'kerberosView':                            '/Online_Help.html#kerberos_view.html', //浏览
	'kerberosModify':                            '/Online_Help.html#kerberos_modify.html', //修改
	
	'cifsService':                            '/Online_Help.html#cifs_service.html', //cifs服务
	'fsLitigationHoldTaskDetail':                            '/Online_Help.html#fs_worm_view.html', //WORM浏览
	'fsLitigationHoldTask':                            '/Online_Help.html#fs_worm.html', //WORM
	'globalsearch':                            '/Online_Help.html#advanced_search.html', //高级搜索
	'nfsService':                            '/Online_Help.html#nfs_service.html', //nfs服务
	'reclamationpolicyConfig':                            '/Online_Help.html#reclamation_policy.html', //配置空间回收策略
	'vvolPG':                            '/Online_Help.html#vvol_lun_pg_view.html', //vvolPG
	
	//容器网络平面
	'containernetworkManage':                            '/Online_Help.html#container_network_manage.html', //管理
	'containernetworkCreate':                            '/Online_Help.html#container_network_create.html', // 创建
	'containernetworkView':                            '/Online_Help.html#container_network_view.html', //浏览
	'containernetworkModify':                            '/Online_Help.html#container_network_modify.html', //修改
	'containernetworkRoute':                            '/Online_Help.html#container_network_route.html', //路由
	'containernetworkAddPort':                            '/Online_Help.html#container_network_add_port.html', //增加端口
	'containernetworkIPRange':                            '/Online_Help.html#container_network_ip.html', //IP地址段
	
	//防病毒服务
	'antivirusConfig':                            '/Online_Help.html#antivirus_config.html', //配置
	'antivirusserverView':                            '/Online_Help.html#antivirus_server_view.html', // 浏览防病毒服务器
	'antivirusserverAdd':                            '/Online_Help.html#antivirus_server_add.html', //增加防病毒服务器
	'antivirustaskView':                            '/Online_Help.html#antivirus_task_view.html', //浏览文件系统扫描任务
	'antivirustaskCreate':                            '/Online_Help.html#antivirus_task_create.html', //创建文件系统扫描任务
	'antivirustaskModify':                            '/Online_Help.html#antivirus_task_modify.html', //修改文件系统扫描任务
	'antiviruspolicyView':                           '/Online_Help.html#antivirus_policy_view.html', //浏览按需扫描策略
	'antiviruspolicyCreate':                            '/Online_Help.html#antivirus_policy_create.html', //创建按需扫描策略
	'antiviruspolicyModify':                            '/Online_Help.html#antivirus_policy_modify.html', //修改按需扫描策略
	'antivirustaskModify':                            '/Online_Help.html#antivirus_task_modify.html', //修改文件系统扫描任务
	'antivirusonaccesspolicyView':                           '/Online_Help.html#antivirus_onaccess_policy_view.html', //浏览实时扫描策略
	'antivirusonaccesspolicyCreate':                            '/Online_Help.html#antivirus_onaccess_policy_create.html', //创建实时扫描策略
	'antivirusonaccesspolicyModify':                            '/Online_Help.html#antivirus_onaccess_policy_modify.html', //修改按实时扫描策略
	'antivirukeyModify':                            '/Online_Help.html#antivirus_preshared_key.html', //修改预共享密钥
	'antivirustaskImmediately':                            '/Online_Help.html#antivirus_task_scan_now.html', //立即扫描
	
	'emailConfig':                            '/Online_Help.html#storagesys_email.html', //配置邮件服务
	'fsActivate':                            '/Online_Help.html#storage_fs_activate.html', //激活文件服务
	
	'vstoreprotectionManage':          '/Online_Help.html#object_vstore.html', //管理
	
	//容器
	'containerSetting':                            '/Online_Help.html#container_set.html', //开启容器服务
	'containerFront-End':                            '/Online_Help.html#container_module_front.html', //前端卡
	'containerBack-End':                            '/Online_Help.html#container_module_back.html', //后端卡
	
	//CIFS Homedir共享
	'cifshomedirCreate':                            '/Online_Help.html#fs_cifs_homedir_create.html', //创建
	'cifshomedirAddMap':                            '/Online_Help.html#fs_cifs_homedir_add_map.html', //增加映射规则
	'cifshomedirModifyMap':                            '/Online_Help.html#fs_cifs_homedir_modify_map.html', //修改映射规则
	
	//文件系统双活
	'fshypermetroCreate':                            '/Online_Help.html#hypermetro_fs_create_manual.html', //创建文件双活Pair
	'fshypermetroView':                            '/Online_Help.html#hypermetro_fs_view.html', //浏览文件双活Pair
	'fshypermetroModify':                            '/Online_Help.html#hypermetro_fs_modify.html', //修改文件双活Pair
	'fshyperdomainCreate':                            '/Online_Help.html#hyperdomain_create_nas.html', //创建文件双活域
	'fsaahyperdomainView':                            '/Online_Help.html#hyperdomain_view_fs.html', //浏览文件双活域-双活模式
	'fssynchyperdomainView':                            '/Online_Help.html#hyperdomain_view_fs_sync.html', //浏览文件双活域-同步模式
	'fsaahyperdomainModify':                            '/Online_Help.html#hyperdomain_modify_fs.html', //修改文件双活域-双活模式
	'fssynchyperdomainModify':                            '/Online_Help.html#hyperdomain_modify_fs_sync.html', //修改文件双活域-同步模式
	'fsvstorehypermetroCreate':                            '/Online_Help.html#hypermetro_vstore_create.html', //创建双活租户Pair
	'fsvstorehypermetroView':                            '/Online_Help.html#hypermetro_vstore_view.html', //浏览双活租户Pair
	'fsaphyperdomainView':                            '/Online_Help.html#hyperdomain_view_fs_ap.html', //浏览文件双活域-ap模式
	'fsaphyperdomainModify':                            '/Online_Help.html#hyperdomain_modify_fs_ap.html', //修改文件双活域-ap模式
	
	'vstoreprotectionView':                            '/Online_Help.html#vstore_protection_view.html', //浏览租户数据保护
	
	'taskProgress':                            '/Online_Help.html#task_progress.html',  //执行结果
	
	'mappingView':                            '/Online_Help.html#map_view.html',  //映射视图
	
	//文件系统克隆
	'fscloneView':                            '/Online_Help.html#clone_fs_view.html', //浏览
	'fscloneCreate':                            '/Online_Help.html#clone_fs_create.html', //创建
	'fscloneModify':                            '/Online_Help.html#clone_fs_modify.html', //修改
	'fscloneDelete':                            '/Online_Help.html#clone_fs_delete.html', //删除
	'fscloneSplit':                            '/Online_Help.html#clone_fs_split.html', //分裂
	
	'auditlogConfig':                            '/Online_Help.html#auditlog_config.html',  //审计日志
	'ndmpSetting':                            '/Online_Help.html#ndmp_config.html',  //ndmp
	
	//SmartCache
	'cachepoolConfigManage':                            '/Online_Help.html#cache_config_manage.html',  //配置和管理
	'cachepoolCreate':                            '/Online_Help.html#cache_create_pool.html',  //创建池
	'cachepoolView':                            '/Online_Help.html#cache_pool_view.html', //浏览池
	'cachepoolExpand':                            '/Online_Help.html#cache_pool_add_disk.html', //扩容池
	'cachepoolModify':                            '/Online_Help.html#cache_pool_modify.html', //修改池
	
	'cachepartitionView':                            '/Online_Help.html#cache_partition_view.html', //浏览分区
	'cachepartitionModify':                            '/Online_Help.html#cache_partition_modify.html', //修改分区
	'cachepartitionAddObject':                            '/Online_Help.html#cache_partition_add_object.html', //增加成员
	'cachepartitionRemoveObject':                            '/Online_Help.html#cache_partition_remove_object.html', //移除成员
	
	'storagesysInfo':                            '/Online_Help.html#storagesys_config_array_info.html',  //设备信息
	
	'exceptionDetection':                            '/Online_Help.html#exception_detection.html',  //异常检测
	
	//回收站
	'lunrecyclebinView':                            '/Online_Help.html#recycle_bin_lun_view.html',  //浏览
	'lunrecyclebinConfig':                            '/Online_Help.html#recycle_bin_lun_delete_automatic.html', //配置
	
	'fsAddtoHyperCDP':                            '/Online_Help.html#fs_add_to_hypercdp.html', //加入HyperCDP
	
	//文件CDP-定时HyperCDP计划
	'fshypercdpplanConfigManage':                            '/Online_Help.html#hypercdp_config_manage_fs.html', //配置和管理CDP
	'fshypercdpplanView':                            '/Online_Help.html#hypercdp_plan_view_fs.html', //浏览CDP
	'fshypercdpplanCreate':                            '/Online_Help.html#hypercdp_plan_create_fs.html', //创建
	'fshypercdpplanAdd':                            '/Online_Help.html#hypercdp_plan_add_fs.html', //增加成员
	'fshypercdpplanRemove':                            '/Online_Help.html#hypercdp_plan_remove_fs.html', //移除成员
	'fshypercdpplanModify':                            '/Online_Help.html#hypercdp_plan_modify_fs.html', //修改
	
	
	//文件CDP-HyperCDP
	'fshypercdpView':                            '/Online_Help.html#hypercdp_view_info_fs.html', //浏览
	'fshypercdpCreate':                            '/Online_Help.html#hypercdp_create_fs.html', //创建
	'fshypercdpRollback':                            '/Online_Help.html#hypercdp_rollback_fs.html', //开始回滚
	'fshypercdpModify':                            '/Online_Help.html#hypercdp_modify_fs.html', //修改
	'fshypercdpModifySpeed':                            '/Online_Help.html#hypercdp_modify_rollback_speed_fs.html', //修改回滚速率
	'performanceView':                            '/Online_Help.html#performance_view.html', //监控指标
	
	//windows用户	
	'authenticationwindowsuserView':                            '/Online_Help.html#authentication_windows_user_view.html', //浏览
	'authenticationwindowsuserCreate':                            '/Online_Help.html#authentication_windows_user_create.html', //创建
	'authenticationwindowsuserModify':                            '/Online_Help.html#authentication_windows_user_modify.html', //修改
	'authenticationwindowsuserAddGroup':                            '/Online_Help.html#authentication_windows_user_add_group.html', //增加所属组
	'authenticationwindowsuserRemoveGroup':                            '/Online_Help.html#authentication_windows_user_remove_group.html', //移除所属组
	'authenticationwindowsuserSecurity':                            '/Online_Help.html#authentication_windows_user_security_policy.html', //设置安全策略
	'authenticationwindowusergroupView':                            '/Online_Help.html#authentication_windows_user_group_view.html', //浏览组
	'authenticationwindowusergroupCreate':                            '/Online_Help.html#authentication_windows_user_group_create.html', //创建组
	'authenticationwindowusergroupModify':                            '/Online_Help.html#authentication_windows_user_group_modify.html', //修改组
	'authenticationwindowusergroupAddUser':                            '/Online_Help.html#authentication_windows_user_group_add_user.html', //增加用户
	
	//用户映射
	'usermappingView':                            '/Online_Help.html#user_map_view.html', //浏览
	'usermappingCreate':                            '/Online_Help.html#user_map_create.html', //创建
	'usermappingModify':                            '/Online_Help.html#user_map_modify.html', //修改
	'usermappingSet':                            '/Online_Help.html#user_map_set.html', //设置
	
	'fsprotectionView':                 '/Online_Help.html#fs_protection_view_info.html', //文件系统数据保护
	
	'alarmLevelModify':                            '/Online_Help.html#alarm_severity.html', //修改告警级别
	
	//CIFS共享
	'cifsView':                            '/Online_Help.html#fs_cifs_view.html', //浏览
	'cifsCreate':                            '/Online_Help.html#fs_cifs_create.html', //创建
	'cifsModify':                            '/Online_Help.html#fs_cifs_modify.html', //修改
	'cifsAddUser':                            '/Online_Help.html#fs_cifs_add_user.html', //增加用户/用户组
	'cifsModifyUser':                            '/Online_Help.html#fs_cifs_user_modify.html', //修改用户/用户组
	'cifsCopy':                            '/Online_Help.html#fs_cifs_copy.html', //模板创建
	'cifsfilefilterAdd':                            '/Online_Help.html#fs_cifs_filefilter_add.html', //增加文件扩展名过滤规则
	'cifsfilefilterModify':                            '/Online_Help.html#fs_cifs_filefilter_modify.html', //修改文件扩展名过滤规则
	
	//VVol
	'vvolManage':                            '/Online_Help.html#vvol_manage.html', //管理
	'vvolView':                            '/Online_Help.html#vvol_lun_view.html', //浏览
	'peView':                            '/Online_Help.html#pe_lun_view.html', //浏览pe
	'peCreate':                            '/Online_Help.html#pe_lun_create.html', //PE创建
	'peModify':                            '/Online_Help.html#pe_lun_modify.html', //PE修改
	'peAddInitiator':                            '/Online_Help.html#pe_lun_add_initiator.html', //增加端口组
	'peModifyLUNID':                            '/Online_Help.html#pe_lun_modify_id.html', //修改主机LUN ID
	'peMap':                            '/Online_Help.html#pe_lun_map.html', //映射
	'peUnmap':                            '/Online_Help.html#pe_lun_unmap.html', //取消映射
	'peAddtoLUNGroup':                            '/Online_Help.html#pe_lun_add_to_group.html', //PE增加到LUN组
	
	//多租户
	'vstoreManage':                            '/Online_Help.html#vstore_service_manage.html', //管理
	'vstoreCreate':                            '/Online_Help.html#vstore_create.html', //创建 
	'vstoreView':                            '/Online_Help.html#vstore_view.html', //浏览 
	'vstoreModify':                            '/Online_Help.html#vstore_modify.html', //修改 
	'vstorednszone':                            '/Online_Help.html#vstore_dns_zone.html', //配置DNSzone
	'fileDnsService':                            '/Online_Help.html#vstore_dns.html', //配置DNS
	
	//RoCE端口
	'roceManage':                            '/Online_Help.html#roce_network.html', //管理RoCE网络
	'roceethernetportView':                            '/Online_Help.html#device_view_roce_port.html', //浏览 
	'roceethernetportModify':                            '/Online_Help.html#device_modify_roce_port.html', //修改  
	'roceethernetportCode':                            '/Online_Help.html#device_view_roce_error_code_number.html', //误码 
    'roceethernetportvlanManage':                            '/Online_Help.html#device_roce_vlan_manage.html', //VLAN  	

	'alarmtrap':          '/Online_Help.html#alarm_trap.html',  //Trap服务器
	
	'storagepoolDelete':                            '/Online_Help.html#storagepool_delete.html', //删除
	
	//快照一致性组创建其他
	'snapshotcgCeateSnapshot':          '/Online_Help.html#snapshot_cg_create_snapshot.html',  //创建快照
	'snapshotcgCeateClone':          '/Online_Help.html#snapshot_cg_create_clone.html',          //创建克隆
	'snapshotcgCeateReplication':          '/Online_Help.html#snapshot_cg_create_replication.html',    //创建远程复制
	
	//文件系统保护
	'fsprotectionManage':          '/Online_Help.html#object_fs.html', //管理
	
	//文件系统快照
	'fssnapshotCreate':                            '/Online_Help.html#snapshot_fs_create.html', //创建
	'fssnapshotView':                            '/Online_Help.html#snapshot_fs_view.html', //浏览
	'fssnapshotModify':                            '/Online_Help.html#snapshot_fs_modify.html', //修改
	'fssnapshotRollBack':                            '/Online_Help.html#snapshot_fs_rollback.html', //回滚
	'fssnapshotModifySpeed':                            '/Online_Help.html#snapshot_fs_modify_speed.html', //修改回滚速率
	
	//文件系统远程复制
	'fsreplicationCreate':                            '/Online_Help.html#replicaiton_fs_create.html', //创建
	'fsreplicationView':                            '/Online_Help.html#replicaiton_fs_view.html', //浏览
	'fsreplicationModify':                            '/Online_Help.html#replicaiton_fs_modify.html', //修改
	
	'fsdns':                            '/Online_Help.html#storage_fs_dns.html', //文件存储DNS服务
	
	//域认证
	'serviceldapView':                            '/Online_Help.html#safe_config_ldap_service.html', //业务平面LDAP
	'servicenisView':                            '/Online_Help.html#safe_config_ldap_nis.html', //业务平面NIS
	'serviceAdView':                            '/Online_Help.html#safe_config_ad_domain.html', //业务平面AD
	
	//漂移组
	'failovergroupsView':                            '/Online_Help.html#failover_groups_view.html', //浏览
	'failovergroupsCreate':                            '/Online_Help.html#failover_groups_create.html', //创建
	'failovergroupsModify':                            '/Online_Help.html#failover_groups_modify.html', //修改
	'failovergroupsAddMember':                            '/Online_Help.html#failover_groups_add_member.html', //增加成员
	'failovergroupsRemoveMember':                            '/Online_Help.html#failover_groups_remove_member.html', //移除成员
	

	//管理
	'fsManage':                            '/Online_Help.html#fs_config_manage.html', //文件系统
	'shareManage':                            '/Online_Help.html#fs_nfs_config_manage.html', //共享
	'accessUserManage':                            '/Online_Help.html#authentication_user_config_manage.html', //认证
	'quotaManage':                            '/Online_Help.html#qouta_config_manage.html', //配额
	'lifNetwork':                            '/Online_Help.html#logical_port_manage.html', //逻辑端口
	
	
	//NFS共享
	'nfsView':                            '/Online_Help.html#fs_nfs_view.html', //浏览
	'nfsCreate':                            '/Online_Help.html#fs_nfs_create.html', //创建
	'nfsModify':                            '/Online_Help.html#fs_nfs_modify.html', //修改
	'nfsAddClient':                            '/Online_Help.html#fs_nfs_add_client.html', //增加客户端
	'nfsModifyClient':                            '/Online_Help.html#fs_nfs_modify_client.html', //修改客户端
	'nfsCopy':                            '/Online_Help.html#fs_nfs_copy.html', //模板创建
	'nfsfilefilterAdd':                            '/Online_Help.html#fs_nfs_filefilter_add.html', //增加文件扩展名过滤规则
	'nfsfilefilterModify':                            '/Online_Help.html#fs_nfs_filefilter_modify.html', //修改文件扩展名过滤规则
	
	//认证用户
	'authenticationuserView':                            '/Online_Help.html#authentication_user_view.html', //浏览
	'authenticationuserCreate':                            '/Online_Help.html#authentication_user_create.html', //创建
	'authenticationuserModify':                            '/Online_Help.html#authentication_user_modify.html', //修改
	
	//认证用户组
	'authenticationusergroupView':                            '/Online_Help.html#authentication_user_group_view.html', //浏览
	'authenticationusergroupCreate':                            '/Online_Help.html#authentication_user_group_create.html', //创建
	'authenticationusergroupModify':                            '/Online_Help.html#authentication_user_group_modify.html', //修改
	
	//配额
	'qoutaView':                            '/Online_Help.html#qouta_view.html', //浏览
	'qoutaCreate':                            '/Online_Help.html#qouta_create.html', //创建
	'qoutaModify':                            '/Online_Help.html#qouta_modify.html', //修改
	'qoutareportersModify':                            '/Online_Help.html#qouta_reporters_modify.html', //修改配额报表
	
	//Dtree
	'dtreeManage':                            '/Online_Help.html#dtree_manage_config.html', //管理
	'dtreeCreate':                            '/Online_Help.html#dtree_create.html', //创建
	'dtreeView':                            '/Online_Help.html#dtree_view.html', //浏览
	'dtreeModify':                            '/Online_Help.html#dtree_modify.html', //修改
	
	//LUN-增加端口组
	'lunAddPortGroup':                            '/Online_Help.html#lun_add_portgroup.html', //增加端口组
	
	//启动器
	'initiatorCreate':                            '/Online_Help.html#initiator_create.html', //创建
	'initiatorModify':                            '/Online_Help.html#initiator_modify.html', //修改
	'initiatorAddHost':                            '/Online_Help.html#initiator_add_host.html', //关联主机
	
	//FC网络
	'fcnetworkView':                            '/Online_Help.html#fc_network_view.html', //浏览
	'fcnetworkCode':                            '/Online_Help.html#fc_network_code.html', //误码统计
	
	//以太网络
	'ethernetnetwork':                            '/Online_Help.html#ethernet_network.html', //管理
	'ethernetportCode':                            '/Online_Help.html#ethernet_port_code.html', //以太网端口-误码统计
	'ethernetbondportCreate':                            '/Online_Help.html#bond_port_create.html', //绑定端口-创建
	'ethernetbondportModify':                            '/Online_Help.html#bond_port_modify.html', //绑定端口-修改
	'ethernetbondportRoute':                            '/Online_Help.html#bond_port_route.html', //绑定端口-路由管理
	'ethernetbondportView':                            '/Online_Help.html#bond_port_view.html', //绑定端口-浏览
	'ethernetlogicalportCreate':                            '/Online_Help.html#logical_port_create.html', //逻辑端口-创建
	'ethernetlogicalportModify':                            '/Online_Help.html#logical_port_modify.html', //逻辑端口-修改
	'logicalportView':                            '/Online_Help.html#logical_port_view.html', //逻辑端口-浏览
	'ethernetlogicalportRoute':                            '/Online_Help.html#logical_port_route.html', //逻辑端口-路由管理
	'ethernetvlanCreate':                            '/Online_Help.html#vlan_create.html', //VLAN-创建
	'ethernetvlanModify':                            '/Online_Help.html#vlan_modify.html', //VLAN-修改
	'lifIPsec':                                 '/Online_Help.html#logical_port_ipsec.html', //IPsec策略
	
	//环形3DC
	'3dcPGCreateall':                            '/Online_Help.html#3dc_create_pg.html', //保护组入口总创建
	'3dcPGCreateReplication':                            '/Online_Help.html#3dc_pg_create_replication.html', //保护组入口-通过保护组创建-同步+异步
	'3dcCGCreateReplication':                            '/Online_Help.html#3dc_pg_cg_create_replication.html', //保护组入口-通过一致性组创建-同步+异步
	'3dcLUNCreate':                            '/Online_Help.html#3dc_create_lun.html', //LUN入口总创建
	'3dcLUNCreateReplication':                            '/Online_Help.html#3dc_create_replication.html', //LUN入口-通过LUN创建-同步+异步
	'3dcPairCreateReplication':                            '/Online_Help.html#3dc_pair_create_replication.html', //LUN入口-通过Pair创建-同步+异步
	
	//快照一致性组
	'snapshotcgActive':                            '/Online_Help.html#snapshot_cg_active.html', //激活
	
	//快照
	'snapshotActive':                            '/Online_Help.html#snapshot_active.html', //激活
	
	//资产清单入口所有操作
	'inventoryView':                            '/Online_Help.html#inventory_view.html', //资产清单
	
	//修改框信息
	'modifyEnclosure':                            '/Online_Help.html#enclosure_modify.html', //修改框
	
	//文件系统
	'fsView':                            '/Online_Help.html#fs_view.html', //浏览
	'fsCreate':                            '/Online_Help.html#fs_create.html', //创建
	'fsModify':                            '/Online_Help.html#fs_modify.html', //修改
	'fsCopy':                            '/Online_Help.html#fs_copy.html', //复制
	'fsModifyCapacity':                            '/Online_Help.html#fs_modify_capacity.html', //修改容量
	
	'multifactorauthentication':                            '/Online_Help.html#multifactor_authentication.html', //多因子认证
	
	'vlanManage':                            '/Online_Help.html#device_vlan_manage.html', //VLAN
	
	'ssoSetting':                            '/Online_Help.html#sso_server.html', //sso服务器
	
    //环形3DC-保护组
	'3dcpgView':                            '/Online_Help.html#3dc_pg_view_info.html', //浏览
	'3dcpgCreate':                            '/Online_Help.html#3dc_pg_create.html', //创建-保护组
	'3dcpgcgCreate':                            '/Online_Help.html#3dc_pg_cg_create.html', //创建-一致性组
	'3dcpgModify':                            '/Online_Help.html#3dc_pg_modify.html', //修改
	
	//环形3DC-LUN
	'3dcView':                            '/Online_Help.html#3dc_view_info.html', //浏览
	'3dcCreate':                            '/Online_Help.html#3dc_create.html', //创建-LUN
	'3dcpairCreate':                            '/Online_Help.html#3dc_pair_create.html', //创建-Pair
	'3dcModify':                            '/Online_Help.html#3dc_modify.html', //修改
	
	//容量介绍
	'initialConfig':                            '/Online_Help.html#storagesys_initial_config.html',
	
	//初始化配置
	'capacityView':                            '/Online_Help.html#capacity_view.html', 
	
	//首页
	'dasboard':                            '/Online_Help.html#dasboard.html', 
	
	//主机
	'hostConfig':                            '/Online_Help.html#host_config.html', //管理
	'hostView':                            '/Online_Help.html#host_view_info.html', //浏览
	'hostCreate':                            '/Online_Help.html#host_create_one.html', //创建
    'hostCreateBatch':                       '/Online_Help.html#host_create_batch.html', //批量创建
	'hostMapGroup':                       '/Online_Help.html#host_map_lun_group.html', //映射到LUN组
	'hostMap':                       '/Online_Help.html#host_map_lun.html', //映射到LUN
	'hostUnmap':                       '/Online_Help.html#host_unmap.html', //取消映射
	'hostAddInitiator':                       '/Online_Help.html#host_add_initiator.html', //增加启动器
	'hostModifyInitiator':                      '/Online_Help.html#host_modify_initiator.html', //修改启动器
	'hostRemoveInitiator':                       '/Online_Help.html#host_remove_initiator.html', //移除启动器
	'hostModify':                            '/Online_Help.html#host_modify.html', //修改
	'hostPathDetails':                            '/Online_Help.html#host_path_details.html', //查看路径详情
	'hostlunidView':                            '/Online_Help.html#host_lun_id_view.html', //查看LUN ID
	'hostlunidModify':                            '/Online_Help.html#host_lun_id_modify.html', //修改LUN ID
	'hostAddPortGroup':                            '/Online_Help.html#host_add_port_group.html', //增加端口组
	
	//主机组
	'hostgroupView':                            '/Online_Help.html#host_group_view_info.html', //浏览
	'hostgroupCreate':                            '/Online_Help.html#host_group_create.html', //创建
	'hostgroupMap':                       '/Online_Help.html#host_group_map.html', //映射到LUN组
	'hostgroupUnmap':                       '/Online_Help.html#host_group_unmap.html', //取消映射
	'hostgroupAddHost':                       '/Online_Help.html#host_group_add_host.html', //增加主机
	'hostgroupRemoveHost':                       '/Online_Help.html#host_group_remove_host.html', //移除主机
	'hostgroupModify':                            '/Online_Help.html#host_group_modify.html', //修改
	'hostgrouplunidView':                            '/Online_Help.html#host_group_lun_id_view.html', //查看LUN ID
	'hostgrouplunidModify':                            '/Online_Help.html#host_group_lun_id_modify.html', //修改LUN ID
	'hostgroupAddPortGroup':                            '/Online_Help.html#host_group_add_port_group.html', //增加端口组
	
	//端口组
	'portgroupView':                            '/Online_Help.html#port_group_view_info.html', //浏览
	'portgroupCreate':                            '/Online_Help.html#port_group_create.html', //创建
	'portgroupAddPort':                       '/Online_Help.html#port_group_add_port.html', //增加端口
	'portgroupRemovePort':                       '/Online_Help.html#port_group_remove_port.html', //移除端口
	'portgroupModify':                            '/Online_Help.html#port_group_modify.html', //修改
	
	//LUN
	'lunView':                            '/Online_Help.html#lun_view_info.html', //浏览
	'lunCreate':                            '/Online_Help.html#lun_create.html', //创建
	'lunMap':                       '/Online_Help.html#lun_map.html', //映射
	'lunUnMap':                       '/Online_Help.html#lun_unmap.html', //取消映射
	'lunExpand':                            '/Online_Help.html#lun_expand.html', //扩容
	'lunCreateSnap':                            '/Online_Help.html#snapshot_create.html', //创建快照
	'lunCreateClone':                            '/Online_Help.html#clone_create.html', //创建克隆
	'lunCreateHyperMetro':                            '/Online_Help.html#hypermetro_create.html', //创建双活
	'lunCreateRemoteReplication':                            '/Online_Help.html#replicaiton_create.html', //创建远程复制
	'lunModify':                            '/Online_Help.html#lun_modify.html', //修改
	'lunCreateHyperCDP':                            '/Online_Help.html#hypercdp_create.html', //创建HyperCDP
	'lunAddtoHyperCDP':                            '/Online_Help.html#lun_add_to_hypercdp.html', //加入HyperCDP
	
	//LUN组
	'lungroupView':                            '/Online_Help.html#lun_group_view_info.html', //浏览
	'lungroupCreate':                            '/Online_Help.html#lun_group_create.html', //创建
	'lungroupMap':                       '/Online_Help.html#lun_group_map.html', //映射
	'lungroupUnMap':                       '/Online_Help.html#lun_group_unmap.html', //取消映射
	'lungroupAdd':                       '/Online_Help.html#lun_group_add.html', //增加LUN
	'lungroupRemove':                       '/Online_Help.html#lun_group_remove.html', //移除LUN
	'lungroupCreateSnap':                            '/Online_Help.html#snapshot_cg_create.html', //创建快照
	'lungroupCreateClone':                            '/Online_Help.html#clone_cg_create.html', //创建克隆
	'lungroupCreateHyperMetro':                            '/Online_Help.html#hypermetro_cg_create.html', //创建双活
	'lungroupCreateRemoteReplication':                            '/Online_Help.html#replication_cg_create.html', //创建远程复制
	'lungroupModify':                            '/Online_Help.html#lun_group_modify.html', //修改
	'lungroupCreateHyperCDP':                            '/Online_Help.html#hypercdp_cg_create.html', //创建HyperCDP
	'lungroupAddtoHyperCDP':                            '/Online_Help.html#lun_group_add_to_hypercdp.html', //加入HyperCDP
	'lungroupAddPortGroup':                            '/Online_Help.html#lun_group_add_portgroup.html', //增加端口组
	
	//存储池
	'storagepoolView':                            '/Online_Help.html#storagepool_view_info.html', //浏览
	'storagepoolCreate':                            '/Online_Help.html#storagepool_create.html', //创建
	'storagepoolExpand':                            '/Online_Help.html#storagepool_expand.html', //扩容
	'storagepoolExport':                            '/Online_Help.html#storagepool_export.html', //导出配置
	'storagepoolRekey':                            '/Online_Help.html#storagepool_rekey.html', //更新密钥
	'storagepoolModify':                            '/Online_Help.html#storagepool_modify.html', //修改
	
	//外部存储
	'externalView':                            '/Online_Help.html#links_view_info.html', //浏览
	'externalAdd':                            '/Online_Help.html#links_create.html', //增加
	'externaleDevLUN':                            '/Online_Help.html#edevlun_create.html', //创建eDevLUN
	'externalAddLink':                            '/Online_Help.html#links_add_iscsi.html', //增加链路
	'externalRemoveLink':                            '/Online_Help.html#links_remove_iscsi.html', //移除链路
	'externalModify':                            '/Online_Help.html#links_amend_name.html', //修改
	'externallunView':                            '/Online_Help.html#links_lun.html', //浏览外部LUN
	'externallinksView':                            '/Online_Help.html#links_view.html', //查看可访问路径
	
	//SmartQOS
	'qosView':                            '/Online_Help.html#qos_view_info.html', //浏览
	'qosCreate':                            '/Online_Help.html#qos_create.html', //创建
	'qosAddObject':                            '/Online_Help.html#qos_add.html', //增加对象
	'qosRemoveObject':                            '/Online_Help.html#qos_remove.html', //移除对象
	'qosModify':                            '/Online_Help.html#qos_modify.html', //修改
	
	//SmartMigration
	'migrationView':                            '/Online_Help.html#migration_view_info.html', //浏览
	'migrationCreate':                            '/Online_Help.html#migration_create.html', //创建
	'migrationConsplit':                            '/Online_Help.html#migration_consplit.html', //一致性分裂
	'migrationModify':                            '/Online_Help.html#migration_modify.html', //修改
	'migrationModifySpeed':                            '/Online_Help.html#migration_modify_speed.html', //修改迁移速率
	
	//保护组
	'pgView':                            '/Online_Help.html#protect_group_view_info.html', //浏览
	'pgCreate':                            '/Online_Help.html#protect_group_create.html', //创建
	'pgCreateSnap':                            '/Online_Help.html#snapshot_cg_create.html', //创建快照
	'pgCreateClone':                            '/Online_Help.html#clone_cg_create.html', //创建克隆
	'pgCreateReplication':                            '/Online_Help.html#replication_cg_create.html', //创建远程复制
	'pgCreateHypermetro':                            '/Online_Help.html#hypermetro_cg_create.html', //创建双活
	'pgAddLUN':                            '/Online_Help.html#protect_group_add.html', //增加LUN
	'pgRemoveLUN':                            '/Online_Help.html#protect_group_remove.html', //移除LUN
	'pgSplit':                            '/Online_Help.html#protect_group_split.html', //分裂
	'pgModify':                            '/Online_Help.html#protect_group_modify.html', //修改
	
	//快照一致性组
	'snapshotcgView':                            '/Online_Help.html#snapshot_cg_view.html', //浏览
	'snapshotcgCreate':                            '/Online_Help.html#snapshot_cg_create.html', //创建
	'snapshotcgReactivate':                            '/Online_Help.html#snapshot_cg_reactivate.html', //重建
	'snapshotcgRollback':                            '/Online_Help.html#snapshot_cg_rollback.html', //开始回滚
	'snapshotcgMap':                            '/Online_Help.html#snapshot_cg_map.html', //映射
	'snapshotcgDuplicate':                            '/Online_Help.html#snapshot_cg_duplicate.html', //创建副本
	'snapshotcgModify':                            '/Online_Help.html#snapshot_cg_modify.html', //修改

	//克隆一致性组
	'clonecgView':                            '/Online_Help.html#clone_cg_view_info.html', //浏览
	'clonecgCreate':                            '/Online_Help.html#clone_cg_create.html', //创建
	'clonecgMap':                            '/Online_Help.html#clone_cg_map.html', //映射
	'clonecgModify':                            '/Online_Help.html#clone_cg_modify.html', //修改
	'clonecgSyn':                            '/Online_Help.html#clone_cg_syn_start.html', //开始反向同步
	'clonecgDelete':                            '/Online_Help.html#clone_cg_syn_delete.html', //删除
	
	//远程复制一致性组
	'replicationcgView':                            '/Online_Help.html#replication_cg_view_info.html', //浏览
	'replicationcgCreate':                            '/Online_Help.html#replication_cg_create.html', //创建
	'replicationcgModify':                            '/Online_Help.html#replication_cg_modify.html', //修改 
	'replicationcgSwitchMode':                            '/Online_Help.html#replication_cg_switch_mode.html', //手动切换复制模式
	'replicationcgAdd':                            '/Online_Help.html#replication_cg_add_pair.html', //增加Pair
	'replicationcgRemove':                            '/Online_Help.html#replication_cg_remove_pair.html', //移除Pair
	
	//双活一致性组
	'hypermetrocgView':                            '/Online_Help.html#hypermetro_cg_view_info.html', //浏览
	'hypermetrocgCreate':                            '/Online_Help.html#hypermetro_cg_create.html', //创建
	'hypermetrocgModify':                            '/Online_Help.html#hypermetro_cg_modify.html', //修改
	
	//LUN
	'lunprotectionView':                            '/Online_Help.html#lun_protection_view_info.html', //浏览
	'lunprotectionCreateSnap':                            '/Online_Help.html#snapshot_create.html', //创建快照
	'lunprotectionCreateClone':                            '/Online_Help.html#clone_create.html', //创建克隆
	'lunprotectionCreateReplication':                            '/Online_Help.html#replicaiton_create.html', //创建远程复制
	'lunprotectionCreateHypermetro':                            '/Online_Help.html#hypermetro_create.html', //创建双活
	
	//快照
	'snapshotView':                            '/Online_Help.html#snapshot_view_info.html', //浏览
	'snapshotCreate':                            '/Online_Help.html#snapshot_create.html', //创建
	'snapshotReactivate':                            '/Online_Help.html#snapshot_reactivate.html', //重建
	'snapshotRollback':                            '/Online_Help.html#snapshot_rollback.html', //开始回滚
	'snapshotDuplicate':                            '/Online_Help.html#snapshot_duplicate.html', //创建副本
	'snapshotModify':                            '/Online_Help.html#snapshot_modify.html', //修改
	
	//克隆
	'cloneView':                            '/Online_Help.html#clone_view_info.html', //浏览
	'cloneCreate':                            '/Online_Help.html#clone_create.html', //创建
	'cloneModify':                            '/Online_Help.html#clone_modify.html', //修改
	'cloneSyn':                            '/Online_Help.html#clone_syn_start.html', //开始反向同步
	'cloneDelete':                            '/Online_Help.html#clone_syn_delete.html', //删除

	//远程复制
	'replicationView':                            '/Online_Help.html#replicaiton_view_info.html', //浏览
	'replicationCreate':                            '/Online_Help.html#replicaiton_create.html', //创建
	'replicationModify':                            '/Online_Help.html#replicaiton_modify.html', //修改
	'replicationSwitchMode':                            '/Online_Help.html#replication_switch_mode.html', //手动切换复制模式
	
	//双活
	'hypermetroView':                            '/Online_Help.html#hypermetro_view_info.html', //浏览
	'hypermetroCreate':                            '/Online_Help.html#hypermetro_create.html', //创建
	'hypermetroModify':                            '/Online_Help.html#hypermetro_modify.html', //修改
	
	//定时HyperCDP计划
	'hypercdpplanConfigManage':                            '/Online_Help.html#hypercdp_config_manage_block.html', //配置和管理CDP
	'hypercdpplanView':                            '/Online_Help.html#hypercdp_plan_view.html', //浏览CDP
	'hypercdpplanCreate':                            '/Online_Help.html#hypercdp_plan_create.html', //创建
	'hypercdpplanAdd':                            '/Online_Help.html#hypercdp_plan_add.html', //增加成员
	'hypercdpplanRemove':                            '/Online_Help.html#hypercdp_plan_remove.html', //移除成员
	'hypercdpplanModify':                            '/Online_Help.html#hypercdp_plan_modify.html', //修改
	
	//HyperCDP一致性组
	'hypercdpcgView':                            '/Online_Help.html#hypercdp_cg_view_info.html', //浏览
	'hypercdpcgCreate':                            '/Online_Help.html#hypercdp_cg_create.html', //创建
	'hypercdpcgRollback':                            '/Online_Help.html#hypercdp_cg_rollback.html', //开始回滚
	'hypercdpcgModify':                            '/Online_Help.html#hypercdp_cg_modify.html', //修改
	'hypercdpcgDuplicate':                            '/Online_Help.html#hypercdp_cg_create_duplicate.html', //创建副本
	
	//HyperCDP
	'hypercdpView':                            '/Online_Help.html#hypercdp_view_info.html', //浏览
	'hypercdpCreate':                            '/Online_Help.html#hypercdp_create.html', //创建
	'hypercdpRollback':                            '/Online_Help.html#hypercdp_rollback.html', //开始回滚
	'hypercdpModify':                            '/Online_Help.html#hypercdp_modify.html', //修改
	'hypercdpDuplicate':                            '/Online_Help.html#hypercdp_create_duplicate.html', //创建副本
	
	//远端设备
	'remotedeviceView':                            '/Online_Help.html#remote_device_view_info.html', //浏览
	'remotedeviceAdd':                            '/Online_Help.html#remote_device_add.html', //增加
	'remotedeviceAddLink':                            '/Online_Help.html#remote_device_add_links.html', //增加链路
	'remotedeviceRemoveLink':                            '/Online_Help.html#remote_device_remove_links.html', //移除链路
	'remotedeviceReconnect':                            '/Online_Help.html#remote_device_reconnect.html', //重连
	'remotedeviceModify':                            '/Online_Help.html#remote_device_modify.html', //修改
	
	//双活域
	'hyperdomainManage':                            '/Online_Help.html#hyperdomain_config_manage.html', //配置和管理
	'hyperdomainView':                            '/Online_Help.html#hyperdomain_view.html', //浏览
	'hyperdomainCreate':                            '/Online_Help.html#hyperdomain_create.html', //创建
	'hyperdomainModify':                            '/Online_Help.html#hyperdomain_modify.html', //修改
	
	//仲裁服务器
	
	'quorumView':                            '/Online_Help.html#quorum_view.html', //浏览
	'quorumCreate':                            '/Online_Help.html#quorum_create.html', //创建
	'quorumModify':                            '/Online_Help.html#quorum_modify.html', //修改
	
	//告警和事件
	'alarmView':                            '/Online_Help.html#check_alarm.html', //告警
	'eventView':                            '/Online_Help.html#check_event.html', //事件
	
	//性能监控
	'dashboardView':                            '/Online_Help.html#dashboard.html', //监控
	'dataView':                            '/Online_Help.html#monitor_data_view.html', //分析
	'powerView':                            '/Online_Help.html#monitor_power_supply_info.html', //功耗
	
	//图表
	'modifyChart':                            '/Online_Help.html#modify_chart.html', //修改图表
	'copyChart':                            '/Online_Help.html#copy_chart.html', //复制图表
	
	//报表任务
	'reporttaskcreate':                            '/Online_Help.html#reporttask_create.html', //创建
	'reporttask':                            '/Online_Help.html#reporttask.html', //浏览
	'reporttaskmodify':                            '/Online_Help.html#reporttask_modify.html', //修改
	'reporttaskexecute':                            '/Online_Help.html#reporttask_execute.html', //立即执行
	'reporttaskEmail':                            '/Online_Help.html#reporttask_email.html', //邮件通知
	
	//预测
	'forecast':                            '/Online_Help.html#forecast.html', 
	
	//任务中心
	'taskcenter':                            '/Online_Help.html#task_manage.html', 
	
	//基本信息
	'timeConfig':                            '/Online_Help.html#storagesys_amend_time.html', //设备时间
	'dnsConfig':                            '/Online_Help.html#storagesys_dns_set.html', //DNS
	
	//块存储服务
	'blockConfig':                            '/Online_Help.html#storage_block_set.html', 
	
	//license
	'licenseView':                            '/Online_Help.html#license_view.html', //浏览
	'licenseUpdate':                            '/Online_Help.html#license_update.html', //更新
	'licenseImport':                            '/Online_Help.html#license_import.html', //导入
	
	//证书
	'certificateView':                            '/Online_Help.html#management_certificate.html', 
	
	//密钥服务
	'encryptView':                            '/Online_Help.html#disk_encrypt_management.html', 
	
	//用户
	'userView':                            '/Online_Help.html#user_view_info.html', //浏览
	'userCreate':                            '/Online_Help.html#user_create.html', //创建
	'userModify':                            '/Online_Help.html#user_amend.html', //修改
	'userUnlock':                            '/Online_Help.html#user_unlock.html', //解锁
	
	
	//角色
	'roleView':                            '/Online_Help.html#role_view.html', //浏览
	'roleCreate':                            '/Online_Help.html#role_create.html', //创建
	'roleModify':                            '/Online_Help.html#role_modify.html', //修改
	
	//安全策略
	'securityConfig':                            '/Online_Help.html#security_strategy_config.html', 
	
	//域认证
	'ldapConfig':                            '/Online_Help.html#safe_config_ldap.html', 
	
	//告警设置
	'alarmnotificationSet':                            '/Online_Help.html#alarm_notification_set.html', //告警通知
	'alarmSave':                            '/Online_Help.html#alarm_alarm_save.html', //转储
	'alarmMask':                            '/Online_Help.html#alarm_masking_management.html', //屏蔽
	'eventnotificationSet':                            '/Online_Help.html#alarm_event_notification.html', //事件通知
	'alarmSound':                            '/Online_Help.html#alarm_config_client_sound.html', //告警声音
	
	//SNMP管理
	'snmpprotocol':                            '/Online_Help.html#snmpProtocol.html', //协议
	'snmpsecuritypolicy':                            '/Online_Help.html#snmpSecurityPolicy.html', //策略
	
	//监控设置
	'monitorSet':                            '/Online_Help.html#monitor_para_set.html', 
	
	//trap
	'trapSet':                            '/Online_Help.html#alarm_trap.html', //管理trap
	//eService
	'eservice':                            '/Online_Help.html#eServiceSetting.html', 
	
	//设置
	
	'storagesysConfig':                            '/Online_Help.html#storagesys_config_array_info.html', //设备信息
	'storagesysUpgrade':                            '/Online_Help.html#storagesys_upgrade.html', //升级
	'storagesysBatchConfig':                            '/Online_Help.html#storagesys_batch_config.html', //批量配置
	'storagesysExport':                            '/Online_Help.html#storagesys_data_export.html', //导出数据
	
	//硬件
	'deviceManage':                            '/Online_Help.html#device_manage.html', //硬件
	'physicalportView':                            '/Online_Help.html#device_view_iscsi.html', //浏览以太网
	'physicalportModify':                            '/Online_Help.html#device_view_modify_iscsi.html', //修改以太网 
	'physicalportCode':                            '/Online_Help.html#device_view_iscsierror_code_number.html', //以太网误码  
	'physicalportRoute':                            '/Online_Help.html#device_config_route.html', //以太网路由  
	'physicalportBond':                            '/Online_Help.html#device_bind_iscsi_port.html', //以太网绑定 
	'bondportModify':                            '/Online_Help.html#device_bind_port_modify.html', //修改绑定端口 
	'physicalportLogicalport':                            '/Online_Help.html#device_logical_port.html', //以太网逻辑端口  
	'managementportModify':                            '/Online_Help.html#device_view_modify_management_port.html', //修改管理口 
	'rdmaportView':                            '/Online_Help.html#device_rdma_port.html', //浏览RDMA端口
	
	'sasportView':                            '/Online_Help.html#device_view_sas.html', //SAS浏览
	'sasportCode':                            '/Online_Help.html#device_view_sas_error_code_number.html', //SAS误码
	
	'diskView':                            '/Online_Help.html#device_view_disk_state.html', //硬盘浏览
	'diskDestruction':                            '/Online_Help.html#device_view_disk_data_destruction.html', //硬盘数据擦除
	'expansionmoduleView':                            '/Online_Help.html#device_view_expansion_module.html', //级联模块浏览
	
	'controldisk':                            '/Online_Help.html#mnt_chk_control_status.html', //控制框/硬盘框
	'controller':                            '/Online_Help.html#mnt_chk_controller.html', //控制器
	'fan':                            '/Online_Help.html#mnt_chk_fan.html', //风扇
	'controllerfan':                            '/Online_Help.html#mnt_chk_controller_fan.html', //控制器和风扇
	'powerunit':                            '/Online_Help.html#mnt_chk_powerunit.html', //电源
	'bbu':                            '/Online_Help.html#mnt_chk_bbu.html', //BBU
	'interface':                            '/Online_Help.html#mnt_chk_interface.html', //串口
	
	//FC端口
	'fcportView':                            '/Online_Help.html#device_view_fc.html', //浏览FC
	'fcportModify':                            '/Online_Help.html#device_modify_fc.html', //修改FC
	'fcportCode':                            '/Online_Help.html#device_view_fc_error_code_number.html', //FC误码 
 
    //接口模块	
	'interfacemoduleView':                            '/Online_Help.html#device_view_interface_module.html', //浏览接口模块
	'interfacemoduleSwitch':                            '/Online_Help.html#device_switch_security_type.html', //切换安全模式
	
	//辅助散热模块
	'assistantcoolingView':                            '/Online_Help.html#device_view_assistant_cooling.html', //浏览接口模块
};
